import styles from './PlaygroundEmpty.module.scss'
import IcPlaygroundEmpty from "./IconPlaygroundEmpty.svg";

const PlaygroundEmpty = () => {
  return (
    <div className={styles.wrapper}>
        <h1>Don't Just Imagine Your Dream Wedding</h1>
        <p>Click on the ‘New Image’ button to create an image</p>
        <img alt="" src={IcPlaygroundEmpty}/>
    </div>
  );
};

export default PlaygroundEmpty;
